import { DetailWrapper } from "../../../../../features/ui"
import { ExpenseDetail } from "./expenseDetail"

export const ExpenseDetailLoader = () => (
    <DetailWrapper>
        <ExpenseDetail />
    </DetailWrapper>
)
